module.exports = __webpack_public_path__ + "static/media/chem-set.d3a03e93.png";